import axios, { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useAxios, apiEndpoints } from 'api';
import { AutoAlertStatus } from 'components';
import {
  AuthorizationEnergyModel,
  QualificationsAdditionalParam,
  QualificationsModel,
  QualificationsUpcoming,
} from 'api/types/Qualifications';

// START Qualification and Authorization Energy

const useGetQualifications = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  { [key: string]: QualificationsModel[] } | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    { [key: string]: QualificationsModel[] } | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<{ [key: string]: QualificationsModel[] }>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/energy`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

const useGetAuthorizationEnergy = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  AuthorizationEnergyModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    AuthorizationEnergyModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<AuthorizationEnergyModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/authorization/energy`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

const useGetQualificationsUpcoming = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  QualificationsUpcoming | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    QualificationsUpcoming | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<QualificationsUpcoming>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/upcoming`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

// END Qualification and Authorization Energy

export default {
  useGetQualifications,
  useGetAuthorizationEnergy,
  useGetQualificationsUpcoming,
};
